export const customStyles = {
  header: {
    style: {
      minHeight: '56px',
    },
  },
  headRow: {
    style: {
      borderRadius: '10px',
      backgroundColor: '#0923E6',
      borderBottomWidth: '0',
    },
  },
  expanderRow: {
    style: {
      // backgroundColor: '#0923E6',
    },
  },
  expanderCell: {
    style: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
      button: {
        backgroundColor: 'transparent !important',
        img: {
          width: '10px',
        },
      },
    },
  },
  expanderButton: {
    style: {
      backgroundColor: 'transparent',
      alignItems: 'center',
    },
  },
  headCells: {
    style: {
      '&:first-child': {
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '0px',
      },
      '&:last-child': {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '0px',
      },
      '&.chart--table-sort-icon': {
        marginLeft: '10px',
      },
      'input[type="checkbox"]': {
        width: '16px',
        height: '16px',
      },
      backgroundColor: '#0923E6',
      width: '250px',
      padding: '20px 20px',
      fontSize: '14px',
      color: '#fff',
      '&:not(:last-of-type)': {
        borderRightStyle: 'solid',
        borderRightWidth: '1px',
        borderRightColor: '#FFFFFF',
      },
      div: {
        color: '#fff',
      },
    },
  },
  cells: {
    style: {
      color: '#07032B',
      fontSize: '14px',
      paddingTop: '10px',
      paddingBottom: '10px',
      'input[type="checkbox"]': {
        width: '16px',
        height: '16px',
      },
      '&:nth-child(1)': {
        div: {
          textOverflow: 'ellipsis',
          display: ' -webkit-box',
          WebkitLineClamp: '2',
          WebkitBoxOrient: 'vertical',
        },
      },
      '&:nth-child(2)': {
        div: {
          textOverflow: 'ellipsis',
          display: ' -webkit-box',
          WebkitLineClamp: '2',
          WebkitBoxOrient: 'vertical',
        },
      },
    },
  },
}
